import React from 'react';
import symbolIcon from '../assets/athena/symbol-icon.png';

// Avatar da Athena nas mensagens — símbolo oficial isolado (263×264, fundo escuro circular).
export const AthenaMiniAvatar = React.memo(function AthenaMiniAvatar({ size = 28 }) {
  return (
    <img
      src={symbolIcon}
      alt="Athena"
      draggable={false}
      style={{
        width:      size,
        height:     size,
        objectFit: 'contain',
        flexShrink: 0,
        display:   'block',
      }}
    />
  );
});
